import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context'
import Table from '../../../components/Table'
import Button from '../../../components/Button'
import moment from 'moment'
import { BiTrash } from 'react-icons/bi'
import Modal from './extraModal/AchieveModal'
import { arrayForSelect } from '../../../utils/arrayForSelect'
import { useDispatch, useSelector } from 'react-redux'
import CustomSelect from '../../../components/CustomSelect'
import { getLibraryPhysicalTrainingIndicators } from '../../../actions/library'
import { createEducationRecord, updateEducationRecord, deleteEducationRecord } from '../../../actions/students/other'


export default function PhysicalTraining() {

  const dispatch = useDispatch()
  const { studentTabData, studentId } = useContext(StudentsContext)

  const { physical_training: physicalData } = studentTabData || {}

  const [selectedItem, setSelectedItem] = useState(null)
  const { schoolYears } = useSelector(state => state.common)
  const { physicalTrainingIndicators } = useSelector(state => state.library)
  const [year, setYear] = useState(null)

  useEffect(() => {
    if (!physicalTrainingIndicators?.length) dispatch(getLibraryPhysicalTrainingIndicators())
  }, []) // eslint-disable-line

  const items = Array.isArray(physicalData) ? physicalData : []

  const handleYearChange = (name, value) => setYear(value)

  const openModal = (data) => () => setSelectedItem(data || {})
  const closeModal = () => setSelectedItem(null)

  const handleSaveItem = (itemData) => {
    if (selectedItem === 'add' || !itemData.id) {
      dispatch(createEducationRecord(studentId, 'physical_training', itemData))
    } else {
      dispatch(updateEducationRecord(studentId, 'physical_training', itemData.id, itemData))
    }
    closeModal()
  }

  const handleDeleteItem = (itemId) => {
    dispatch(deleteEducationRecord(studentId, 'physical_training', itemId))
  }

  const renderLi = (item) => {
    const { id, indicator_id, value, taken } = item
    const indicatorName = (physicalTrainingIndicators || []).find(i => i.iid === indicator_id)?.iname || indicator_id || ''
    return (
      <tr key={id} onClick={openModal(item)}>
        <td>{indicatorName}</td>
        <td>{value || ''}</td>
        <td>{taken ? moment(taken).format('DD.MM.YYYY') : ''}</td>
        <td>
          <i className={styles.trash} onClick={(e) => { e.stopPropagation(); handleDeleteItem(id) }}>
            <BiTrash />
          </i>
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem === 'add' ? {} : selectedItem}
          height={'430px'}
          addMode={selectedItem === 'add'}
          tabType='physical_training'
          onSave={handleSaveItem}
        />
      }

      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Учебный год'
            valuesName='year'
            options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
            width='120px'
            value={year}
            setFieldValue={handleYearChange}
          />
        </div>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Показатель</th>
              <th>Значение</th>
              <th>Дата</th>
              <th>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {items.map(renderLi)}
          </tbody>
        </Table>
        <br />
        <Button onClick={openModal('add')}>Добавить</Button>
      </div>
    </div>
  )
}
